import { AVAILABILITY_FILTER_OPTIONS } from 'data/subOptions/availabilitySubOptions';
import { Filter, SearchMode } from 'model/Filters';

import BookingActions from './BookingActions';
import FiltersActions from './FiltersActions';
import NavigationActions from './NavigationActions';
import SearchActions from './SearchActions';

export interface FiltersActionsInterface {
  setGuests(guests: { nrOfAdults: number; nrOfChildren: number }): void;
  setLocation(location: { country: string; city: string }): void;
  setSearchMode(mode: SearchMode): void;
  setFilters(filters: {
    country?: string;
    city?: string;
    activeFilters: Filter[];
    page?: number;
  }): void;
  flushFilters(): void;
  setDates(dates: { selectedFrom: string; selectedTo: string }): void;
  setAvailabilityFilter(availability: {
    availability: AVAILABILITY_FILTER_OPTIONS;
  }): void;
  setFilterLang(lang: string);
}

export default function (flux) {
  flux.addActions(NavigationActions);
  flux.addActions(FiltersActions);
  flux.addActions(SearchActions);
  flux.addActions(BookingActions);
}
